// import Campaign from '../components/Campaign.vue'
import AsideOfMain from "./AsideOfMain.vue";
// import MobileFooter from './MobileFooter'
import ClarificationText from "./ClarificationText";
export default {
  name: 'SubLayout',
  components: {
    'ClarificationText': ClarificationText,
    'aside-of-main': AsideOfMain
    // 'mobile-footer': MobileFooter
  },
  data: function data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    cachedViews: function cachedViews() {
      return ['CustomerRepresentative', 'Faqs', 'PaymentInformation'];
    }
  },
  created: function created() {},
  methods: {
    openKvkkLink: function openKvkkLink() {
      window.open('https://www.iyifinans.com.tr/kvkk/', '_blank');
    },
    goToDetail: function goToDetail() {
      this.dialogVisible2 = false;
      this.$router.push({
        name: 'payment-information',
        path: '/payment-information'
      });
    }
  }
};